module.exports = __webpack_public_path__ + "img/bg.a02e282d.jpg";